import betImgPinkCandy from '../assets/images/bet-item-img1.png';
import betImgGreenCandy from '../assets/images/bet-item-img3.png';
import betImgYellowCandy from '../assets/images/bet-item-img2.png';
import betImgBlueCandy from '../assets/images/bet-item-img4.png';
import betImgBonusCandy from '../assets/images/bet-bonus-img.png';

export const candyNames = {
  Pink: 'Pink',
  Green: 'Green',
  Blue: 'Blue',
  Yellow: 'Yellow',
  Bonus: 'Bonus',
};

export const candyIndexByName = {
  [candyNames.Pink]: 1,
  [candyNames.Green]: 2,
  [candyNames.Blue]: 3,
  [candyNames.Yellow]: 4,
  [candyNames.Bonus]: 5,
};

export const candiesByIndex = {
  1: betImgPinkCandy,
  2: betImgGreenCandy,
  3: betImgBlueCandy,
  4: betImgYellowCandy,
  5: betImgBonusCandy,
};

export const candiesByNames = {
  [candyNames.Pink]: betImgPinkCandy,
  [candyNames.Green]: betImgGreenCandy,
  [candyNames.Blue]: betImgBlueCandy,
  [candyNames.Yellow]: betImgYellowCandy,
  [candyNames.Bonus]: betImgBonusCandy,
};

export const candiesButtonInitialData = [
  {
    index: candyIndexByName[candyNames.Bonus],
    isBetBlockOpen: false,
    amount: null,
  },
  {
    index: candyIndexByName[candyNames.Green],
    isBetBlockOpen: false,
    amount: null,
    odd: 3,
  },
  {
    index: candyIndexByName[candyNames.Blue],
    isBetBlockOpen: false,
    amount: null,
    odd: 3,
  },
  {
    index: candyIndexByName[candyNames.Pink],
    isBetBlockOpen: false,
    amount: null,
    odd: 3,
  },
  {
    index: candyIndexByName[candyNames.Yellow],
    isBetBlockOpen: false,
    amount: null,
    odd: 3,
  },
];
